import * as React from 'react';
const SvgHeartEmpty = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" fill="none" viewBox="0 0 16 16" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.509 15.309C13.448 12.389 16 9.27 16 5.893c0-4.787-5.29-6.364-8-3.374-2.71-2.99-8-1.413-8 3.374 0 3.377 2.552 6.497 7.491 9.416a1 1 0 001.018 0zm.402-10.56C10.188 1.93 14 2.668 14 5.893c0 2.413-1.951 4.893-6 7.387-4.049-2.494-6-4.974-6-7.387 0-3.225 3.812-3.964 5.089-1.144a1 1 0 001.822 0z"
            fill="currentColor"
        />
    </svg>
);
export default SvgHeartEmpty;
